import React from 'react';
import { StyledButton } from './index.styled';
// import { Spin } from 'antd';
type ButtonProps = {
  name?: string;
  variant?: 'text' | 'outlined' | 'dashed' | 'link' | 'solid' | 'filled';
  color?: 'default' | 'primary' | 'danger';
  type?: 'primary' | 'dashed' | 'link' | 'text' | 'default';
  icon?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  rightIcon?: React.ReactNode;
  leftIcon?: React.ReactNode;

  [x: string]: any;
};

const AppButton: React.FC<ButtonProps> = ({
  name,
  type = 'primary',
  color = 'primary',
  icon,
  variant,
  className,
  onClick,
  disabled,
  loading,
  rightIcon,
  leftIcon,
  ...rest
}: ButtonProps) => (
  <StyledButton
    type={type}
    color={color}
    icon={icon}
    onClick={onClick}
    variant={variant}
    className={className}
    disabled={disabled}
    loading={loading}
    {...rest}
  >
    {leftIcon}
    {name}
    {rightIcon}
    {/* {loading && <Spin size="small" />} */}
  </StyledButton>
);
export default AppButton;
